import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Send } from "lucide-react";
interface DeepDiveFormProps {
  reference: string;
  isLoading: boolean;
  onReferenceChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}
const DeepDiveForm: React.FC<DeepDiveFormProps> = ({
  reference,
  isLoading,
  onReferenceChange,
  onSubmit
}) => {
  return <form onSubmit={onSubmit} className="max-w-2xl mx-auto">
      <div className="flex flex-col sm:flex-row gap-3">
        <input type="text" placeholder="Ex. John 3:16, Romans 8:28-39, Psalm 23" value={reference} onChange={e => onReferenceChange(e.target.value)} className="flex-1 h-12 px-4 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-heaven-gold/30 focus:border-transparent py-[16px]" />
        <Button type="submit" className="bg-black text-white hover:bg-gray-800 h-12 px-6 rounded-lg w-full sm:w-auto" disabled={isLoading}>
          {isLoading ? <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Analyzing...
            </> : <>
              <Send className="mr-2 h-4 w-4" />
              Send
            </>}
        </Button>
      </div>
    </form>;
};
export default DeepDiveForm;